var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column justify-center align-center fill-height"},[_c('v-icon',{attrs:{"size":"80","color":"grey"}},[_vm._v(" question_answer ")]),_c('span',{staticClass:"grey--text body-2"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }